/**
 * Settled Filter Component for Contract List
 */
import React from 'react'

import { useTranslation } from 'react-i18next'

import { Checkbox } from '@enechain/ecloud-designsystem'

interface SettledFilterProps {
  excludeSettled: boolean
  onExcludeSettledChange: (excludeSettled: boolean) => void
}

export const SettledFilter: React.FC<SettledFilterProps> = ({
  excludeSettled,
  onExcludeSettledChange,
}) => {
  const { t } = useTranslation(['page'])

  return (
    <Checkbox
      checked={excludeSettled}
      onCheckedChange={(details) =>
        onExcludeSettledChange(details.checked === true)
      }
    >
      {t('page:contract_list.filter.exclude_settled')}
    </Checkbox>
  )
}
